// Module
var code = "<base-sort-dropdown params=\"options: baseSortDropdownOptions\"></base-sort-dropdown>";
// Exports
export default code;